import _ from "lodash";

const isTypePodcast = (type) => {
  let isPodcast = false;
  try {
    const obj = JSON.parse(type);
    if (_.isPlainObject(obj)) {
      obj.type === "podcast" ? (isPodcast = true) : (isPodcast = false);
    }
  } catch (e) {
    return isPodcast;
  }
  return isPodcast;
};

const validatePodcastObject = (podcast) => {
  try {
    const obj = JSON.parse(podcast);
    if (_.isPlainObject(obj)) {
      return obj;
    }
  } catch (e) {
    return {};
  }
  return {};
};

const whooshkaaPlayer = (vid) => {
    let win = null;
    try {
      const videoURL = `https://webplayer.whooshkaa.com/episode/${vid}?theme=light&waveform-progress-color=%23FA6800`;
      const vH = 200;
      const vW = 800;
      const wd = window.outerWidth - vW;
      const ht = window.outerHeight - vH;
      const left = wd / 2;
      const top = ht / 2;
      if (win) {
        win.close();
      }
      win = window.open(
        videoURL,
        "Paypal",
        `location=no,status=no,menubar=no,toolbar=no,scrollbars=no,status=no,width=${vW},height=${vH},top=${top}, left=${left}`
      );
      if (document.getElementById("videoOverlayWhooshka")) {
        document.getElementById("videoOverlayWhooshka").style.display = "block";
      }
      window.onfocus = function youkuOverlay() {
        if (document.getElementById("videoOverlayWhooshka")) {
          document.getElementById("videoOverlayWhooshka").style.display =
            "none";
        }
        if (
          win !== undefined &&
          modelData.modelData.client_info.client_type === "dedicated"
        ) {
          win.close();
        }
      };
    }
    catch (e) {
        console.log("error", e)
        return null;
    }
}

module.exports = {
  isTypePodcast,
  validatePodcastObject,
  whooshkaaPlayer
};
